import { CalendarTextOutlineIcon } from './CalendarTextOutlineIcon';

/**
 * author: Google
 * id F49AE0DB-5AAF-4574-BF4C-121E99A95BEF
 * name calendar-text-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-text-outline.svg
 * tags
 * - Date / Time 
 */
export const EventTextOutlineIcon = CalendarTextOutlineIcon;
export default EventTextOutlineIcon